<template>
	<template v-if="showVersionSelect">
		<SelectPlanVersionV2
			v-if="useV2Select"
			:key="`${index}importPlanSelect`"
			v-model:selectedPlan="selectedPlan"
			:plan="plan"
			:index="index"
			:autoloadLatestPlan="autoloadLatestPlan"
			:selectedPriceBook="selectedPriceBook"
			@planSelected="(args) => emit('planSelected', args)"
			@createNewPlan="(args) => emit('createNewPlan', args)"
		/>
		<SelectPlanVersion
			v-else
			:key="`${index}importPlanSelect`"
			v-model:selectedPlan="selectedPlan"
			:leadId="plan!.leadId!"
			:plan="plan"
			:index="index"
			:autoloadLatestPlan="autoloadLatestPlan"
			:selectedPriceBook="selectedPriceBook"
			@planSelected="(args) => emit('planSelected', args)"
			@createNewPlan="(args) => emit('createNewPlan', args)"
		/>
	</template>
	<WalkInPlanVersion
		v-else-if="plan"
		:plan="plan"
	/>
</template>

<script setup lang="ts">
import type { PriceBook } from '@/classes/PriceBook'
import { Feature, useFeatureService } from '@/services/featureService'
import type { PlanData } from '@/types'
import SelectPlanVersion from '@/views/NewSession/PlanVersions/SelectPlanVersion.vue'
import SelectPlanVersionV2 from '@/views/NewSession/PlanVersions/SelectPlanVersionV2.vue'
import WalkInPlanVersion from '@/views/NewSession/PlanVersions/WalkInPlanVersion.vue'
import { computed, type PropType } from 'vue'

const props = defineProps({
	plan: {
		type: Object as PropType<Partial<PlanData>>,
		required: false,
	},
	index: {
		type: Number,
		required: true,
	},
	autoloadLatestPlan: {
		type: Boolean,
		require: true,
	},
	selectedPriceBook: {
		type: Object as PropType<PriceBook | undefined>,
		required: false,
	},
	appointmentId: {
		type: [String, null],
		required: false,
	},
})

const emit = defineEmits(['planSelected', 'createNewPlan'])

const selectedPlan = defineModel('selectedPlan', {
	type: [String, null],
	required: false,
})

/**
 * We do not want to show version select if plan is
 * a walk-in (no appointment ID)
 * We also need to wait for some props to load
 */
const showVersionSelect = computed(
	() =>
		(props.plan?.leadId || props.plan?.opportunityId) && !!props.appointmentId
)

const useV2Select = computed(() =>
	useFeatureService().isEnabled(Feature.SalesforceIntegration)
)
</script>
